import { CardType } from "../../../models/Card";
import { CardVariant } from "../../../models/CardVariant";
import { IFilterCommand } from "../IFilterCommand";

export type CostFilterArgs = {
    costs: number[]
}

export class CostFilter<TItem extends CardVariant> implements IFilterCommand<TItem, CostFilterArgs> {
    isMatch(item: TItem, args: CostFilterArgs = { costs: [] }): boolean {
        // No costs provided, which means we're not filtering on cost.
        if (!args.costs.length) {
            return true;
        }

        const cardCost = item?.card?.cost;
        if (!cardCost) {
            return false;
        }

        let isMatch = false;
        for (const item of args.costs) {
            isMatch = isMatch || item === cardCost;
        }

        return isMatch;
    }
}